import { Box, Tab, TabList, Tabs } from "@chakra-ui/react";
import { useContext } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../Context/AuthProvider";

const AdminLayout = () => {
  const { isSuperUser } = useContext(AuthContext);

  const tabs = [
    // { path: "/admin/data-edit", label: "Edit Data" },
    { path: "/admin/data-edit", label: "Edit Data" },
    { path: "/admin/edit-edss-model", label: "Edit Edss Model" },
    // { path: "/admin/edit-model", label: "Edit Model" },
    { path: "/admin/edit-codes", label: "Edit Codes" },
    { path: "/admin/security", label: "Security" },
    { path: "/admin/duplicate", label: "Person Deduplication" },
    { path: "/admin/caseDedup", label: "Case Deduplication" },
    { path: "/admin/super-role", label: "Super User", superOnly: true },
  ];

  const location = useLocation();
  const visibleTabs = tabs.filter((t) => !t.superOnly || isSuperUser);
  const activeIndex = visibleTabs.findIndex((tab) =>
    location.pathname.startsWith(tab.path),
  );

  return (
    <Box m={{ base: 4, md: 4 }}>
      <Tabs
        variant="line"
        size="md"
        mt={4}
        index={activeIndex !== -1 ? activeIndex : 0}
      >
        <TabList gap={4}>
          {visibleTabs.map((tab) => (
            <NavLink
              to={tab.path}
              key={tab.path}
              style={{ textDecoration: "none" }}
            >
              <Tab
                _selected={{
                  bg: "bgColor",
                  color: "white",
                  fontWeight: "bold",
                }}
                _hover={{ bg: "bgColor", color: "white" }}
              >
                {tab.label}
              </Tab>
            </NavLink>
          ))}
        </TabList>
      </Tabs>
      <Box mt={1}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;
